@if (form && control) {
  <div [formGroup]="form">
    <app-material-input
      [type]="type"
      [require]="require"
      [placeholder]="placeholder"
      [formControlName]="field_name">
      <ng-content></ng-content>
    </app-material-input>
  </div>
}
